<template>
  <p :class="$style.free_shipping">全国一律 送料無料でお届け</p>
</template>

<style module lang="scss">
.free_shipping {
  text-align: center;
  font-size: $font-size-12;
  font-weight: bold;
}
</style>
